import React from 'react';
import PropTypes from 'prop-types';

export const SuccessMessage = (props) => {
    const {
        message,
        heading,
        extraMessage
    } = props;
    return (
        <div className="success-message">
            <div className="d-flex align-content-center mb-4">
                <div className="d-flex align-items-center justify-content-center">
                    <img src={'/_resources/themes/anz-courtside/dist/images/tick.png'} alt="tick" className="mr-4"/>
                </div>
                <h2 className="mb-0">{heading}</h2>
            </div>
            <p className={'message'}>{message}</p>
            {extraMessage && <p className={'extra-message'}>{extraMessage}</p>}
        </div>
    )
}

SuccessMessage.propTypes = {
    heading: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
}

SuccessMessage.defaultProps = {
    extraMessage: ''
}
